export default "__VITE_ASSET__WgUSNkDq__"